import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import type { AmbiguityReport } from "@/lib/intel/disambiguation-types";

export type { AmbiguityReport, IdentityCandidate } from "@/lib/intel/disambiguation-types";

export const assessIdentityAmbiguity = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input) =>
    z
      .object({
        target: z.string().trim().min(2).max(180),
        targetType: z.string().trim().max(40).default("person"),
        refine: z.record(z.string(), z.string()).optional(),
        environment: z.enum(["sandbox", "live"]).default("live"),
      })
      .parse(input),
  )
  .handler(async ({ data, context }): Promise<AmbiguityReport> => {
    const { requireEntitlement } = await import("@/lib/payments/entitlements.server");
    await requireEntitlement({
      supabase: context.supabase,
      userId: context.userId,
      feature: "ai",
      environment: data.environment,
    });
    const { assessAmbiguity } = await import("@/lib/intel/disambiguation.server");
    return assessAmbiguity({ target: data.target, targetType: data.targetType, refine: data.refine });
  });
